exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bottomToolbarContainer {\n  background-color: var(--headbandColor);\n  color: var(--headbandTextColor);\n  width:105%;\n}\n.bottomToolbarInner {\n  width: 290%;\n  padding: 0px;\n  display: block;\n  border-top: 1px solid #e5e5e5;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a8b116a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/bottomToolbar/bottomToolbar.vue
// module id = 1538
// module chunks = 2